export default {
    data() {
        return {};
    },
    methods: {
        activeteFirstElement() {
            console.log('here');
        },
    },
};
